import React from "react";
import ReferralNavbar from "./ReferralNavbar";
import UserImg from "../../asstes/UnknownUser.webp";
import { FaArrowUp, FaGift, FaRegUser } from "react-icons/fa";
import { CgInfo } from "react-icons/cg";
import { CiPenpot } from "react-icons/ci";
import { SiBlockchaindotcom, SiParamountplus } from "react-icons/si";
import { FaUsersGear } from "react-icons/fa6";
import Footer from "../Footer/Footer";
import { HiCubeTransparent } from "react-icons/hi2";
import { BsTransparency } from "react-icons/bs";
import { FaTransgender } from "react-icons/fa6";
import { SiHiveBlockchain } from "react-icons/si";
import { LuArchiveRestore } from "react-icons/lu";
import { PiUsersFourFill } from "react-icons/pi";
import { GiGiftTrap } from "react-icons/gi";
const data = [
  {
    date: "07-06-2024",
    id: 1,
    address: "0x86...927C",
    amount: 100.5,
  },
  {
    date: "07-06-2024",
    id: 2,
    address: "0x86...927Cw",
    amount: 200.75,
  },
  {
    date: "07-06-2024",
    id: 3,
    address: "0x86...927Ca",
    amount: 300.8,
  },
  {
    date: "07-06-2024",
    id: 4,
    address: "0x86...927Cv",
    amount: 400.25,
  },
  {
    date: "07-06-2024",
    id: 5,
    address: "0x86...927CR",
    amount: 500.6,
  },
  {
    date: "07-06-2024",
    id: 6,
    address: "0x86...927CVR",
    amount: 600.45,
  },
  {
    date: "07-06-2024",
    id: 7,
    address: "0x86...927CN",
    amount: 700.3,
  },
  {
    date: "07-06-2024",
    id: 8,
    address: "0x86...927CJ",
    amount: 800.85,
  },
  {
    date: "07-06-2024",
    id: 9,
    address: "0x86...927CU",
    amount: 900.9,
  },
  {
    date: "07-06-2024",
    id: 10,
    address: "0x86...927CZ",
    amount: 1000.15,
  },
];
const Referral = () => {
  return (
    <>
      <ReferralNavbar />
      <div className="referralMainConatainer">
        <div className="referralinnerConatainer">
          <section className="referralUserProfileDiv">
            <div className="referralUserdetail comm">
              <div className="UserImg">
                <img src={UserImg} alt="Img" />
              </div>
              <div className="UserData">
                <h1>User Name</h1>
                <p>User Email</p>
                <p>User Address</p>
                <p className="Invited-rflpage">
                  Invited 07-06-2024 by
                  <span className="ID-span-rfl">
                    ID 13 <FaArrowUp className="arrow-icon-rfl" />
                  </span>
                </p>
              </div>
            </div>
            <div className="referralUserreferral comm">
              <div className="Referral-Link">
                <div>
                  <p className="Referral-Link-p">
                    Referral Link <CgInfo />
                  </p>
                  <p className="Referral-Link-url">
                    https://myreview.website/5XrOiV
                  </p>
                </div>
                <div className="copy-btn-div">
                  <button>Copy</button>
                </div>
              </div>
            </div>
          </section>
          {/* UserProfile section-End */}

          {/* Transaction-Start */}
          <section className="referralUserTransaction">
            <div className="Transaction-text">
              <h1>Transactions</h1>
              <span className="Transaction-info-text">
                info <CgInfo />
              </span>
            </div>
            <div className="inputdiv">
              <input type="text" placeholder="Enter Amount" />
              <button>Invest Now</button>
            </div>
            <div className="transactiondiv">
              <div className="minAmountdiv Min">
                <div className="minAmountdivheader">
                  <h1>Min Amount</h1>
                  <SiHiveBlockchain className="transactiondiv-icon" />
                </div>
                <h1 className="amount-text">
                  <span className="doller-sine">$</span> 250
                </h1>
                <div className="minAmountdivheader">
                  <FaTransgender className="transactiondiv-icon" />
                </div>
              </div>
              {/* minAmountdiv-End */}
              <div className="maxAmountdiv Min">
                <div className="minAmountdivheader">
                  <h1>Max Amount</h1>
                  <SiParamountplus className="transactiondiv-icon" />
                </div>
                <h1 className="amount-text">
                  <span className="doller-sine">$</span> 10, 000
                </h1>
                <div className="minAmountdivheader">
                  <BsTransparency className="transactiondiv-icon" />
                </div>
              </div>
              {/* maxAmountdiv-End */}
              <div className="Total-Transaction Min">
                <div className="minAmountdivheader">
                  <h1>Total Transaction Limit</h1>
                  <SiBlockchaindotcom className="transactiondiv-icon" />
                </div>
                <h1 className="amount-text">
                  <span className="doller-sine">$</span> 2, 00, 000
                </h1>
                <div className="minAmountdivheader">
                  <LuArchiveRestore className="transactiondiv-icon" />
                </div>
              </div>
              {/* Total-Transaction-End */}
            </div>
          </section>
          {/* Transaction Section-End */}

          {/* User-Teams-details-section-Start */}
          <section className="referralUserTeams">
            <div className="UserTeams-text">
              <h1>User</h1>
              <span className="UserTeams-info-text">
                info <CgInfo />
              </span>
            </div>
            <div className="UserTemas-history-div">
              <div className="User-address-container user-add-his">
                <div className="User-add-Team-main">
                  <div className="User-address comm-add-team userteamhover">
                    <p className="user-id-rfl">ID 13</p>
                    <p>
                      Address: <span>0x86...927C</span>
                    </p>
                    <div className="icon-div-user-his">
                    <GiGiftTrap />

                      <div className="design-div">
                        <CiPenpot />
                      </div>
                    </div>
                  </div>
                  <div className="User-Teams-contanier comm-add-team userteamhover">
                    <p>User Teams </p>
                    <div className="text-div">
                    <p className="text-size">5</p>
                    </div>
                    <div className="icon-div-user-his">
                    <GiGiftTrap />

                      <div className="design-div">
                        <FaUsersGear />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="User-reward-container userteamhover">
                  <p>Your Rewards</p>
                  <div className="text-div">
                  <p className="text-size">10</p>
                  </div>
                  <div className="icon-div-user-his">
                  <GiGiftTrap />
                    <div className="design-div reward">
                      <FaGift />
                    </div>
                  </div>
                </div>
              </div>
              {/* ------ */}
              <div className="User-history-container ">
                <h1 className="history-info-text">
                Transactions Histroy <CgInfo />
              </h1>
                <div className="table-div">
                  <table>
                    <tr className="tr">
                      <td>Date</td>
                      <td>ID</td>
                      <td>Address</td>
                      <td>Amount</td>
                    </tr>
                    {data.map((item, index) => {
                      return (
                        <>
                          <tr>
                            <td>{item.date}</td>
                            <td>{item.id}</td>
                            <td>{item.address}</td>
                            <td>$ {item.amount}</td>
                          </tr>
                        </>
                      );
                    })}
                  </table>
                </div>
              </div>
            </div>
          </section>
          {/* User-Team-details-section-End */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Referral;
